import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ItemsService } from '../../../../services/items.service';
import { ViewUpdateService } from '../../../../services/view-update.service';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

@Component({
  selector: 'scaffold-table-like-columns',
  templateUrl: './table-like-columns.component.html',
  styleUrls: ['./table-like-columns.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class TableLikeColumnsComponent extends BaseScaffoldComponent
  implements OnInit, OnDestroy {
  public destroy$: Subject<boolean> = new Subject<boolean>();
  sortColumn;
  reversed;
  created = false;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private itemsService: ItemsService,
    private viewUpdate: ViewUpdateService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  sortBy(column) {
    if (column) {
      console.log(column)
      if (this.sortColumn === column) {
        this.reversed = !this.reversed;
      }
      this.sortColumn = column;
      if (this.item?.list_content?.listItems) {
        this.item.list_content.listItems.sort((a, b) => {
          let sortA = a.data.find((x) => x.name === column).value;
          let sortB = b.data.find((x) => x.name === column).value;
          if (sortA > sortB) {
            return this.reversed ? -1 : 1;
          }
          if (sortA < sortB) {
            return this.reversed ? 1 : -1;
          }
          return 0;
        });
      }
    }

  }

  createData() {
    let position = this.item.list_content.listItems[this.item.list_content.listItems.length - 1].position;
    position = position ? Number(position) + 1 : this.item.list_content.listItems.length + 1 
    let type = this.item.list_view;
    if (!this.created) {
      this.created = true;

      const default_data = {
        type: type,
        data: {},
        return_view : this.item.columns
      };
      if (position) {
        default_data.data["position"] = position;
      }
      let path = "";
      if (this.info) {
        path += this.info.type + "/" + this.info.id + "/";
      }
      path += type;
      const placeholder = {
        type: type,

        data: {
          content: [
            {
              type: "text",
              value: default_data.data["title"] || type,
            },
          ],
        },
      };
      if (position) {
        placeholder["position"] = position;
      }
      this.viewUpdate.triggerListChange({
        list_type: "list",
        placeholder: placeholder,
        type: type,
        parent_type: this.info.type,
        parent_id: this.info.id,
      });
      this.itemsService
        .createData(path, default_data)
        .subscribe((d) => {
          this.created = false;
          this.item.list_content.listItems.push(d);
          this.update();
        });
    }


  }

}
